import { ThemeProvider } from "@cynthai/ui";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect } from "react";
import { Toaster } from "sonner";

import { useTheme } from "@/core/hooks/use-theme";
import { persistOptions, queryClient } from "@/core/lib/query-client";
import { router } from "@/core/lib/router";

function MainContextProvider() {
  const theme = useTheme();

  useEffect(() => {
    document.body.classList.add(theme);

    return () => {
      document.body.classList.remove(theme);
    };
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={persistOptions}
      >
        <Toaster richColors position="top-right" duration={5000} closeButton />
        <RouterProvider router={router} />
      </PersistQueryClientProvider>
    </ThemeProvider>
  );
}

export default MainContextProvider;
